import React, { useState, useEffect } from "react";
import { array, func, bool, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import More from "../../atoms/More";
import LeftImageRightNews from "../../molecules/LeftImageRightNews";
import DfpAd from "../../dfp-ad";

import { staticTexts } from "../../utils/Translate";

import "./stories2AdWithLoadMore.m.css";

const TransparentOverlay = () => {
  return <div styleName="transparent-overlay"></div>;
};

const Stories2AdWithLoadMore = ({
  pageType,
  list,
  onLoadMore = null,
  isMoreStories = false,
  loading = false,
  lang,
  sideAd = lang === "en"
    ? pageType === "section-page"
      ? "EnPalo_ROS_300x250_R2"
      : "EnPalo_ROS_336x280_R1"
    : pageType === "section-page"
    ? "News_336x280_R2"
    : "News_336x280_R1",
  midAd = lang === "en"
    ? pageType === "section-page"
      ? "EnPalo_ROS_300x250_R3"
      : "EnPalo_ROS_300x250_R2"
    : pageType === "section-page"
    ? "News_336x280_R3"
    : "News_336x280_R2",
  moreAd = lang === "en" ? "EnPalo_ROS_336x280_R3" : "News_336x280_R3",
}) => {
  const [isMobile, setIsMobile] = useState(false);
  const [showButtonSpinner, setButtonSpinner] = useState(false);
  useEffect(() => {
    setIsMobile(global.deviceWidth < 876);

    if (!loading) {
      setButtonSpinner(false);
    }
  }, [loading]);

  if (isMobile && pageType === "section-page") {
    midAd = lang === "en" ? "EnPalo_ROS_300x250_R2" : "News_336x280_R2";
    sideAd = moreAd;
  } else if (isMobile && !(pageType === "section-page")) {
    midAd = lang === "en" ? "EnPalo_ROS_336x280_R1" : "News_336x280_R1";
    sideAd = lang === "en" ? "EnPalo_ROS_300x250_R2" : "News_336x280_R2";
  }

  if (!(list && list.length)) {
    return null;
  }
  const storyList = [...list]; // Make a copy of it to avoid changing of list

  const handleButtonClick = (e) => {
    setButtonSpinner(true);
    onLoadMore(e);
  };

  const MoreComponent = (
    <div styleName="load-more-view">
      <More
        type="load-more"
        text={staticTexts(lang).more}
        onClick={handleButtonClick}
        showButtonSpinner={showButtonSpinner}
      />
    </div>
  );

  return (
    <>
      {showButtonSpinner && <TransparentOverlay />}
      <div styleName="wrapper" className="two-stories-with-load-more-wrapper">
        {!isMobile && <div className="space-hide-mobile" />}
        <div className="stories-set" styleName="stories_set">
          {storyList.length > 0 &&
            storyList.map((story, index) => (
              <React.Fragment key={index}>
                {index !== 0 && (index % 10 === 5 || index === 5) && (
                  <div styleName="ad-wrapper">
                    <div styleName="ad-slot">
                      <DfpAd adtype={index === 5 ? midAd : moreAd} slotId={`Stories2AdWithLoadMore-${index}`} />
                    </div>
                  </div>
                )}
                <LeftImageRightNews
                  story={story}
                  widths={global.deviceWidth < 876 ? [150] : [200]}
                  showExcerpt={!isMobile}
                />
              </React.Fragment>
            ))}

          {isMoreStories ? MoreComponent : null}
        </div>

        <div>
          <div styleName="side-ad" className="side-ad">
            <DfpAd adtype={sideAd} slotId="Stories2AdWithLoadMore-sideAd" />
          </div>
        </div>
      </div>
    </>
  );
};

Stories2AdWithLoadMore.propTypes = {
  list: array,
  onLoadMore: func,
  setLoading: func,
  loading: bool,
  isMoreStories: bool,
  lang: string,
  sideAd: string,
  midAd: string,
  moreAd: string,
  pageType: string,
};

Stories2AdWithLoadMore.storyLimit = 15;

const mapStateToProps = (state) => ({
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], ""),
  pageType: get(state, ["qt", "pageType"], ""),
});

export default connect(mapStateToProps)(Stories2AdWithLoadMore);
